/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react'
import {useSelector,useDispatch} from 'react-redux'
import { setButtonOkLoad, setModalsProps } from '../../../../redux/modals';
import { ApiCall, CurrencyDetails, defultOkButton, getMulValues, pythonUrl, INCOME_TYPE_TAB, getValue, CATALOG_TABLE_TEXT, 
         CATALOG_TABLE_DATE, CATALOG_TABLE_ROYALTY, number_regex, CATALOG_TABLE_TYPES, CATALOG_TABLE_TYPES_ICON, CATALOG_TABLE_DETAILS, CATALOG_TABLE_GROSS, CATALOG_TABLE_NPS, CATALOG_TABLE_ROYALTY_TITLE, CATALOG_MISC_TYPES, CATALOG_MISC_TYPES_ICON, CATALOG_TABLE_MISC  } from '../../../../Data/Variables';
import { useCookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { numberWithCommas, numberWithOutCommas } from '../functions';

const MiscInput = ({type,year,setInputData,inputData}) =>
{
    return  <div className='columns is-centered is-vcentered'>
                <div className='column m-1 p-1 is-narrow'>
                    <span>{year}</span>
                </div>
                <div className='column m-1 p-1 is-narrow'>
                    <input className={'input has-text-right ' + (number_regex.test(getMulValues(inputData,[type,year],"")) ? "" : "is-danger")} type="text" placeholder='Enter Value' 
                        onFocus={(e) => {if(e.target.value !== undefined) setInputData({...inputData, [type]  : {...inputData[type], [year] :  numberWithOutCommas(e.currentTarget.value)          }});}}
                        onBlur={(e) => {if(e.target.value !== undefined)  setInputData({...inputData, [type]  : {...inputData[type], [year] :  numberWithCommas(parseFloat(e.currentTarget.value)) }});}} 
                        onChange={(e) => {if(e.target.value !== undefined) setInputData({...inputData, [type] : {...inputData[type], [year] :  numberWithOutCommas(e.currentTarget.value)          }});}} 
                        value={getMulValues(inputData,[type,year], 0)}/>
                </div>
            </div>
}
const MiscTab = ({type,inputData,setInputData}) =>
{

    const acq_date = new Date(getMulValues(inputData,[CATALOG_TABLE_DETAILS,CATALOG_TABLE_DATE[0]],""));
    const start_year = acq_date.getFullYear();
    const start_quarter = Math.ceil(acq_date.getMonth()/3);
    let year_comp_temp = []

    for (let year = start_year; year <= start_year + 7; year++) {
        let quarterStart = (year === start_year) ? start_quarter : 1;
        let quarterEnd = (year === start_year + 7) ? start_quarter : 4;

        for (let quarter = quarterStart; quarter <= quarterEnd; quarter++) {
            year_comp_temp.push(
                <React.Fragment key={year_comp_temp.length}>
                    <MiscInput type={type} year={year+" Q"+quarter} setInputData={setInputData} inputData={inputData}/>
                </React.Fragment>
            );
        }
    }
        
  
    return  <center className='pt-5' style={{'height' : '80%', 'overflowY' : 'scroll'}}>
                {year_comp_temp}
            </center>
}

const TdInput = ({inputData,setInputData,income,year,type,inputTable}) =>
{
    return <input className={'input has-text-right ' + (number_regex.test(getMulValues(inputData,[type,inputTable,income,year],"")) ? "" : "is-danger")} type="text" placeholder='Enter Budget' 
                   onFocus={(e) => {if(e.target.value !== undefined) setInputData({...inputData, [type] : {...inputData[type],[inputTable] : {...inputData[type][inputTable],[income] : {...inputData[type][inputTable][income], [year] : numberWithOutCommas(e.currentTarget.value) }}}});}}
                   onBlur={(e) => {if(e.target.value !== undefined) setInputData({...inputData, [type] : {...inputData[type],[inputTable] : {...inputData[type][inputTable],[income] : {...inputData[type][inputTable][income], [year] : numberWithCommas(parseFloat(e.currentTarget.value)) }}}}); }}
                   onChange={(e) => {if(e.target.value !== undefined) setInputData({...inputData, [type] : {...inputData[type],[inputTable] : {...inputData[type][inputTable],[income] : {...inputData[type][inputTable][income], [year] : numberWithOutCommas(e.currentTarget.value) }}}}); }}
                   value={getMulValues(inputData,[type,inputTable,income,year], 0)}/>

}

const CatalogInput = ({value,setInputData,inputData,conditionProb,type,classaddon}) =>
{  
    
    return  <center>
                <input className={'input '+((conditionProb(getMulValues(inputData,[type,value],""))) ? "" : "is-danger")+" "+classaddon }  
                       onChange={(e) => 
                        {
                            setInputData({...inputData, [type] : {...inputData[type], [value] : e.currentTarget.value}})
                        }} value={getMulValues(inputData,[type,value],"")} />
            </center>
}
const CatalogMakeTable = ({inputData,setInputData,type,inputTable}) =>
{
    const { theCatalog } = useSelector((state) => state.portal);

    return(
        <>
        <table className="table is-scrollable is-gapless is-striped is-narrow">
            <thead>
                <tr>
                    <th><b>Catalog Name</b></th>
                    {CATALOG_TABLE_TEXT.map((val,i) => 
                    {
                        return <React.Fragment key={i}><th><b>{val}</b></th></React.Fragment>
                    })}
                    {CATALOG_TABLE_DATE.map((val,i) => 
                    {
                        return <React.Fragment key={i}><th><b>{val}</b></th></React.Fragment>
                    })}
                    {CATALOG_TABLE_ROYALTY.map((val,i) => 
                    {
                        return <React.Fragment key={i}><th><b>{getValue(CATALOG_TABLE_ROYALTY_TITLE,val,val)}</b></th></React.Fragment>
                    })}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className='td_center_text'><h1 className='subtitle is-5 mr-2' >{theCatalog}</h1></td>
                    {CATALOG_TABLE_TEXT.map((val,i) => 
                    {
                        return <React.Fragment key={i}>
                                <td>
                                    <CatalogInput inputData={inputData} type={type}
                                        setInputData={setInputData} value={val} inputTable={inputTable}
                                        conditionProb={(value) => {return value !== ""}}/>
                                </td>
                                </React.Fragment>
                    })}
                    {CATALOG_TABLE_DATE.map((val,i) => 
                    {
                        return <React.Fragment key={i}>
                                <td>
                            
                                    <DatePicker className={'input ' + (getMulValues(inputData,[type,val],null) === null ? "is-danger" : "")} 
                                        selected={getMulValues(inputData,[type,val],null)} dateFormat="dd-MM-yyyy"
                                        onChange={(data) =>
                                        {
                                            setInputData({...inputData, [type] :{...inputData[type], [val]  : data}})
                                        }}/>
                                </td>
                                </React.Fragment>
                    })}
                    {CATALOG_TABLE_ROYALTY.map((val,i) => 
                    {
                        return <React.Fragment key={i}>
                                <td>
                                    <CatalogInput inputData={inputData} type={type}
                                        classaddon={"has-text-right"}
                                        setInputData={setInputData} value={val}
                                        conditionProb={(value) => {return /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d+(\.\d+)?$/.test(value)}}/>
                                </td>
                                </React.Fragment>
                    })}
                </tr>
            </tbody>
        </table>
        </>
    );
}
const addYears = new Date().getFullYear()+6;
const BudgetMakeTable = ({tableData,inputData,setInputData,type,inputTable}) =>
{
    const [inputDataInit,setInputDataInit] = useState(true)
    console.log(inputData)

    let th = Object.keys(tableData);
    let tr = Object.values(tableData);
    let thAry = [];
    let trAry = [];
    let default_input_data = {}
    if (inputDataInit)
        default_input_data = {[CATALOG_TABLE_GROSS] : {...getMulValues(inputData,[type,CATALOG_TABLE_GROSS],{})}, 
                              [CATALOG_TABLE_NPS] : {...getMulValues(inputData,[type,CATALOG_TABLE_NPS],{})}}
        
    for(let i=0;i<th.length;i++)
    {
        thAry.push(<React.Fragment key={i}><th className="title is-6">{th[i]}</th></React.Fragment>);
    }
    const thlen = parseInt(th[th.length-1].trim())+1;
    for(let i=thlen;i<addYears;i++)
    {
        const year = i+" "
        thAry.push(<React.Fragment key={i}><th className="title is-6 has-text-right">{year}</th></React.Fragment>);
        th.push(year)
    }
    
    let y=1;
    let total = {};
    for(;y<tr[0].length;y++)
    {
        let tdAry = [];
        for(let x = 0;x<tr.length;x++)
        {  
            tr[x][y] = tr[x][y]+"";
            tdAry.push(<React.Fragment key={y*tr[0].length+x}><td className={x != 0 ? 'has-text-right' : ""}><span >{y === tr[0].length-1 ? <b>{tr[x][y]}</b> : tr[x][y]}</span></td></React.Fragment>);
        }
        if (y !== 0)
        {
            const trlen = tr.length+(addYears-thlen);
            if(y !== tr[0].length-1)
            {
                for(let x = tr.length;x<trlen;x++)
                {  
                    const income = tr[0][y];
                    const year = th[x];
                    if (inputDataInit)
                    {
                        if (!(year in getValue(default_input_data[CATALOG_TABLE_GROSS],income,{})))
                            default_input_data[CATALOG_TABLE_GROSS] = {...default_input_data[CATALOG_TABLE_NPS],[income] : 
                                                                        {...default_input_data[CATALOG_TABLE_GROSS][income],[year] : ""}} 
                        if (!(year in getValue(default_input_data[CATALOG_TABLE_NPS],income,{})))
                            default_input_data[CATALOG_TABLE_NPS] = {...default_input_data[CATALOG_TABLE_NPS],[income] : 
                                                                        {...default_input_data[CATALOG_TABLE_NPS][income],[year] : ""}} 
                    } 
                    total[x] = getValue(total,x,0) + parseFloat((getMulValues(inputData,[type,inputTable,income,year],"")+"").replace(",",""));
                    tdAry.push(<React.Fragment key={y*tr[0].length+x}>
                        <td>
                            <TdInput inputData={inputData} setInputData={setInputData} income={income} year={year} type={type} inputTable={inputTable}/>
                        </td>
                        </React.Fragment>); 
                }
            }
            else
            {
                for(let x = tr.length;x<trlen;x++)
                {  
                    tdAry.push(<React.Fragment key={y*tr[0].length+x}><td className={x != 0 ? 'has-text-right' : ""}><span >{<b>{total[x] ? numberWithCommas(total[x]) : "-"}</b>}</span></td></React.Fragment>);
                }
            }
        }

        trAry.push(<React.Fragment key={y}><tr className='tr_hovered'>{tdAry}</tr></React.Fragment>)
    }
    useEffect(() =>
    {
        if (inputDataInit)
        {
            console.log(default_input_data)
            setInputData({...inputData, [type] : {...default_input_data}})
            setInputDataInit(false);
        }
    },[inputDataInit])
    

   
    return(
        <div className='box'>
            <table className="table is-hoverable is-scrollable is-gapless is-striped is-narrow" style={{"overflowY" : "scroll","overflowX" :"none","padding": "0"}}>
                <thead>
                    <tr>{thAry}</tr>
                </thead>
                <tbody>
                    {trAry}
                </tbody>
            </table>    
        </div>
    );
}
const ModelDuplicate = ({inputData,setInputData,currtab,setCurrTab}) =>
{
    const { modalsProps } = useSelector((state) => state.modals);
    const dispatch = useDispatch();
    return(
        <div className={"modal "+(modalsProps["modelDuplicate"] ? "is-active" : "" )}>
            <div className="modal-background"></div>
            <div className="modal-card">
                <header className="modal-card-head">
                <p className="modal-card-title">Duplicate Data</p>
                <button className="delete" aria-label="close" onClick={() => dispatch(setModalsProps({...modalsProps,"modelDuplicate" : false}))}></button>
                </header>
                <section className="modal-card-body">
                    <h1 className='title is-4'>Are you sure you want to import the data from the other tab to this tab?</h1>
                </section>
                <footer className="modal-card-foot">
                    <div className='fullwidth'>
                        <div className='is-pulled-right'>
                            <button className="button" onClick={() => dispatch(setModalsProps({...modalsProps,"modelDuplicate" : false}))}>Cancel</button>
                            <button className="button is-success" onClick={() => 
                                            {
                                                    dispatch(setModalsProps({...modalsProps,"modelDuplicate" : false}));
                                                    setInputData({...inputData, [CATALOG_TABLE_TYPES[currtab]] : inputData[CATALOG_TABLE_TYPES[1-currtab]]});
                                            } }>Save changes</button>
                        </div>
                    </div>
                </footer>
            </div>
        </div>);
}
const IncomeTab = ({type,inputData,jwt,setInputData,tabledata,currtab,setCurrTab,get_income,getTableLoad}) =>
{
    const [, setCookies, ] = useCookies();
    const { modalsProps } = useSelector((state) => state.modals);
    const dispatch = useDispatch();

    const downloadBudget = async () =>
    {
        let tempdata = JSON.parse(JSON.stringify(inputData[type]))
        delete tempdata['Total']
        let params = 
        {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded',"Authorization" : jwt},
            body: new URLSearchParams(
            {
                "data" : JSON.stringify(tempdata),
                'dicttype' : "budget"
            })
        }
        let data = await ApiCall(pythonUrl+"/Dict2Excel",params,setCookies,(err) => 
        {
            alert("Data Error. Please contact us at data@bitsonic.ai");
        });
        data = await data.blob()
        const blob = new Blob([data]);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'file.xlsx'; // You can set the file name here
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    const uploadBudget = async () =>
    {
        let input = document.createElement('input');
        input.style.visibility = 'hidden';
        input.type = 'file';
        input.onchange = e => 
        { 
            let file = e.target.files[0]; 
            let req = new XMLHttpRequest();
            req.open("POST", pythonUrl+"/Excel2Dict", true);
            req.responseType = 'json';
            let formData = new FormData();
            formData.append('file', file)
            formData.append('dicttype','budget')
            req.withCredentials = false;        
            req.send(formData);

            req.onreadystatechange = () =>
            {
                if (req.readyState === XMLHttpRequest.DONE && req.response !== "NONE")
                {
                    const jsonstring = req.response;
                    setInputData({...inputData,[type] : jsonstring});
                    req.abort();
                }
            }
            req.onerror = () =>
            {
                alert("Data Error. Please contact us at data@bitsonic.ai");
                req.abort();
            }
        }
        input.click();
    }
    const acq_date = getMulValues(inputData,[CATALOG_TABLE_DETAILS,CATALOG_TABLE_DATE[0]],"") ;

    return  <center style={{"height" : "100%"}}>
                <ModelDuplicate inputData={inputData} setInputData={setInputData} currtab={currtab} setCurrTab={setCurrTab}/>
                <div className='buttons is-centered mb-0'>
                    <span className='title mr-3 mb-3'>Edit {type.charAt(0).toUpperCase() + type.slice(1)}</span>
                    <button className={"button is-small is-light mr-1 is-primary bordered bordered"}  onClick={(e) => {uploadBudget()}} ><i className="fa-solid fa-upload "></i></button>
                    <button className={"button is-small is-light is-info bordered"}  onClick={(e) => {downloadBudget()}}><i className="fa-solid fa-download"></i></button>
                    <button className={"button is-small is-light is-info bordered"} title='data will imported to this file from the other tab'  onClick={(e) => {
                            dispatch(setModalsProps({...modalsProps,"modelDuplicate" : true}))
                        }}><i className="fa-solid fa-file-import"></i></button>
                </div>
                <div className="is-divider m-0 mb-2"></div>
                <div  style={{'overflowY' : 'scroll',"height" : "80%"}}>
                    <CatalogMakeTable inputData={inputData} setInputData={setInputData} type={CATALOG_TABLE_DETAILS}/> 
                    <div className="is-divider"></div>
                    {!tabledata || Object.keys(inputData) === 0 ? 
                        <>
                            <button className={'button is-light is-link bordered ' + getTableLoad} 
                                    onClick={() => {get_income(inputData[CATALOG_TABLE_DETAILS])}}
                                    disabled={acq_date === "" || acq_date === null || acq_date === undefined}  >Get Table</button>
                        </>
                    :
                        <>
                            <h1 className='title is-4'>Underwritten Gross NPS</h1>
                            <BudgetMakeTable tableData={tabledata} inputData={inputData} setInputData={setInputData} type={type} inputTable={CATALOG_TABLE_GROSS}/>
                            <div className="is-divider"></div>
                            <h1 className='title is-4'>Underwritten Net NPS</h1>
                            <BudgetMakeTable tableData={tabledata} inputData={inputData} setInputData={setInputData} type={type} inputTable={CATALOG_TABLE_NPS}/>
                        </>
                    }

                </div>
            </center>
}


const TabComponenet = ({tabname,icon,index,currtab,setCurrTab,isValid}) =>
{
  
  return <li className={currtab === index ? "is-active" : ""}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
            <a className='blacktab' onClick={() => setCurrTab(index)}>
              <span className="icon is-small "><i className={icon}/></span>
              <span>{tabname}</span>
              {isValid ? 
                null
              : <span className='dotWarn has-background-danger'>
                    <center><i className="fa-solid fa-exclamation"/></center>
                </span> }
            </a>
          </li>
}

const validateNumber = (obj) => Object.keys(obj).every(k => typeof obj[k] === "object" ? validateNumber(obj[k]) : number_regex.test(obj[k]));
// const validateNumberPrint = (obj) => Object.keys(obj).map(k => typeof obj[k] === "object" ? validateNumberPrint(obj[k]) : obj[k]);

const ModelBudget = ({jwt,incomeTabPack,clientName}) =>
{
    const { catalogDetails,theCatalog,tabMenuList} = useSelector((state) => state.portal);
    const { modalsProps } = useSelector((state) => state.modals);
    const {OrigRenme,tabtofolder} = useSelector((state) => state.globalVars);
    const { outputTitle} = useSelector((state) => state.customOutput);

    const dispatch = useDispatch();

    const [, setCookies, ] = useCookies();
    const [inputData,setInputData] = useState({});
    const [tabledata,setTableData] = useState(undefined);
    const [currtab,setCurrTab] = useState(0);

    const [getTableLoad,setGetTableLoad] = useState("");

    const isNotString = (str) => {return str !== "" && str !== null && str !== undefined}

    const valid_TABLE_TYPES = CATALOG_TABLE_TYPES.map(x => validateNumber(getValue(inputData,x,{"" : ""})));
    const valid_TABLE_TEXT = CATALOG_TABLE_TEXT.map(x => isNotString(getMulValues(inputData,[CATALOG_TABLE_DETAILS,x],undefined)));
    const valid_TABLE_DATE = CATALOG_TABLE_DATE.map(x => isNotString(getMulValues(inputData,[CATALOG_TABLE_DETAILS,x],undefined)));
    const valid_TABLE_ROYALTY = CATALOG_TABLE_ROYALTY.map(x => x === undefined || x === null || x == "" ||  number_regex.test(getMulValues(inputData,[CATALOG_TABLE_DETAILS,x],undefined)));
    const saveBudget = async () =>
    {
        let params = 
        {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded',"Authorization" : jwt},
            body: new URLSearchParams(
            {
                "catalog_id" : catalogDetails[theCatalog]["_id"],
                "data" : JSON.stringify(inputData)
            })
        }
        await ApiCall(pythonUrl+"/SaveBudget",params,setCookies,(err) => 
        {
            alert(err);
            dispatch(setButtonOkLoad(defultOkButton));
        });
        //data = await data.json();
        dispatch(setModalsProps({...modalsProps,"budgetModel" : false}))
    }



    useEffect(() =>
    {

        const get_details = async  () =>
        {
            let params = 
            {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded',"Authorization" : jwt},
                body: new URLSearchParams(
                    {"catalog_id" : catalogDetails[theCatalog]["_id"]})
            }
            let data = await ApiCall(pythonUrl+"/GetBudgetDetails",params,setCookies,(err) => 
            {
                alert(err);
                dispatch(setButtonOkLoad(defultOkButton));
            });
            data = await data.json();
            setInputData({[CATALOG_TABLE_DETAILS] : {...data}});
            const acq_date = getMulValues(data,[CATALOG_TABLE_DATE[0]],"") ;
            if (!(acq_date === "" || acq_date === null || acq_date === undefined))
                get_income(data)
        }
        if(modalsProps['budgetModel'] && Object.keys(inputData).length === 0)
            get_details();
    
    },[modalsProps])

    const get_income = async  (cata_details) =>
    {
        setGetTableLoad('is-loading');
        let params = 
        {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded',"Authorization" : jwt},
            body: new URLSearchParams(
            {
                "catalog_id" : catalogDetails[theCatalog]["_id"],
                "theTab" : INCOME_TYPE_TAB,
                "tabKind" :  tabtofolder[OrigRenme[theCatalog][incomeTabPack]],
                "clientName" : clientName,
                "currencyMode" : getMulValues(tabMenuList[theCatalog],[CurrencyDetails,"details","currencyMode"],"Fixed"),
                "currency": 1/outputTitle["currencies"][theCatalog][outputTitle["currencyKey"][theCatalog].toLowerCase()],
                "currencyKey" : outputTitle["currencyKey"][theCatalog],
                "yearStatementCurr" : undefined,
                "yearStatementTarrget" : "Year",
                "isbudget" : true,
                'acq_date' : new Date(cata_details[CATALOG_TABLE_DATE[0]]).getTime()
            })
        }
        let data = await ApiCall(pythonUrl+"/GetCatalogOutput",params,setCookies,(err) => 
        {
            alert(err);
            dispatch(setButtonOkLoad(defultOkButton));
        });
        data = await data.json();
        
        setInputData({...data[1],[CATALOG_TABLE_DETAILS] : {...cata_details}});
        setTableData(data[0]);
        setGetTableLoad('');
        // get here incometype sheet
        // totals from bottom and from right side of screen
        // generate reports.
    }

    return (<div className={modalsProps["budgetModel"] ? "modal is-active" : "modal"} style={{"zIndex" : 30}}>
                <div className="modal-background"></div>
                <div className="modal-card m-0 p-0" style={{"width": "90%","height": "90%"}}>
                    <header className="modal-card-head">
                        <p className="modal-card-title">Budget Settings - {theCatalog}</p>
                        <button className="delete" onClick={()=>{dispatch(setModalsProps({...modalsProps,"budgetModel" : false}))}}></button>
                    </header>
                    <section className="modal-card-body"  style={{'overflowY' : 'hidden'}}>
                        <div className="tabs is-boxed is-centered is-fullwidth">
                            <ul>
                                {CATALOG_TABLE_TYPES.map((x,i) => 
                                    <React.Fragment key={i}>
                                        <TabComponenet tabname={x.charAt(0).toUpperCase() + x.slice(1)} index={i} currtab={currtab} 
                                                        setCurrTab={setCurrTab} icon={CATALOG_TABLE_TYPES_ICON[i]} isValid={valid_TABLE_TYPES[i]}/>
                                    </React.Fragment>
                                )}
                                {CATALOG_MISC_TYPES.map((x,i) => 
                                    <React.Fragment key={i}>
                                        <TabComponenet tabname={x.charAt(0).toUpperCase() + x.slice(1) + " Income"} index={CATALOG_TABLE_TYPES.length+i} currtab={currtab} 
                                                        setCurrTab={setCurrTab} icon={CATALOG_MISC_TYPES_ICON[i]} isValid={true}/>
                                    </React.Fragment>
                                )}
                            </ul>
                        </div>
                            {CATALOG_TABLE_TYPES.map((x,i) => 
                                i === currtab ?
                                    <React.Fragment key={i}>
                                        <IncomeTab  type={x} inputData={inputData} jwt={jwt} setInputData={setInputData} tabledata={tabledata}
                                                    currtab={currtab} setCurrTab={setCurrTab} get_income={get_income} getTableLoad={getTableLoad}/>
                                    </React.Fragment>
                                : null
                            )}
                            {CATALOG_MISC_TYPES.map((x,i) => 
                                (CATALOG_TABLE_TYPES.length+i) === currtab && inputData[CATALOG_TABLE_TYPES[0]] ?
                                    <React.Fragment key={i}>
                                       <MiscTab type={x} inputData={inputData} setInputData={setInputData} />
                                    </React.Fragment>
                                : null
                            )}
                    </section>
                    <footer className="modal-card-foot">
                        <div className='fullwidth'>
                            <div className='is-pulled-right'>
                                <button className="button" onClick={()=>{dispatch(setModalsProps({...modalsProps,"budgetModel" : false}))}}>Cancel</button>
                                <button className="button is-success" onClick={() => {saveBudget()}} >Save changes</button>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>);
}
export default ModelBudget;